import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class ScheduleItemService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('ScheduleItem');
	}

	loadForDeliveryZoneGroup(id: System.Guid): Observable<TooBig4Car.Logic.ScheduleItem[]> {
		return this.myBaseService.loadAll(this.url + '/ForDeliveryZoneGroup/' + (id || ''));
	}
	loadOffScheduleForDeliveryZoneGroup(id: System.Guid): Observable<TooBig4Car.Logic.ScheduleItem[]> {
		return this.myBaseService.loadAll(this.url + '/OffScheduleForDeliveryZoneGroup/' + (id || ''));
	}
	loadForTruck(id: System.Guid): Observable<TooBig4Car.Logic.ScheduleItem[]> {
		return this.myBaseService.loadAll(this.url + '/ForTruck/' + (id || ''));
	}
	loadForCustomerAccount(id: System.Guid): Observable<TooBig4Car.Logic.ScheduleItem[]> {
		return this.myBaseService.loadAll(this.url + '/ForCustomerAccount/' + (id || ''));
	}
	getNewSchedule(): Observable<TooBig4Car.Logic.ScheduleItem> {
		return this.myBaseService.getPlain(this.url + '/EditNewSchedule', 'Failed to load new schedule');
	}
}

